export var getColumnId = function (column) { var _a; return (_a = column.id) !== null && _a !== void 0 ? _a : column.key; };
